(function () {
  "use strict";

  angular
    .module("admin.scheduled_messages.service", [])
    .factory("ScheduledMessageAppService", ScheduledMessageAppService);

  /** @ngInject */
  function ScheduledMessageAppService($http, $q, API) {
    function list(start, limit) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/scheduled_messages?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=id-desc"
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listExpired(start, limit) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/scheduled_messages/expired?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=id-desc"
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listPending(start, limit) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/scheduled_messages/pending?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=id-desc"
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function get(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/scheduled_messages/" + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function save(model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/scheduled_messages", model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/scheduled_messages/" + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/scheduled_messages/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      list: list,
      listExpired: listExpired,
      listPending: listPending,
      get: get,
      save: save,
      update: update,
      remove: remove,
    };
  }
})();
